import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { PurchasingService } from '../../../services/purchasing.service';
import { PrintService } from '../../../services/print.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { OpenPurchaseOrdersComponent } from '../../../shared/open-purchase-orders/open-purchase-orders.component';

@Component({
	selector: 'app-vendordash-open-pos',
	templateUrl: './vendordash-open-pos.component.html',
	styleUrls: ['./vendordash-open-pos.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
	]
})
export class VendordashOpenPosComponent implements OnInit {
	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();
	viewing: any = false;

	data: any = false;
	title = 'Open Purchase Orders';
	allpurchaseorders: any = [];
	exporting = false;
	@ViewChild('openPurchaseOrders') openPurchaseOrdersComponent: OpenPurchaseOrdersComponent;

	constructor(
		private purchasingService: PurchasingService,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.purchasingService.getPurchaseOrders().subscribe((results: any) => {
			if (results && results.pos) {
				this.data = results.pos;
				this.allpurchaseorders = results;
			}
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: this.title };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	exportPdf() {
		if (this.openPurchaseOrdersComponent) {
			this.openPurchaseOrdersComponent.exportPdf();
		}
	}

	exportXls() {
		if (this.openPurchaseOrdersComponent) {
			this.openPurchaseOrdersComponent.exportXls();
		}
	}
}
